// navigation-control.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationControlService {
    forceExit = false;
}